<div class="pt-2 mt-3">
  <div class="row no-gutters">
    <div
      class="col-12 d-flex gap-3 justify-content-between align-items-center pr-2"
    >
      <h5 class="section-title">Hold Points</h5>
      <mat-checkbox
        *ngIf="(holdPoints?.length ?? 0) > 1"
        [disabled]="!canEditHoldPointSignOrder"
        [checked]="requireHoldPointSignOrder"
        (change)="requireHoldPointSignOrder = $event.checked"
      >
        Require Hold Point sign order
      </mat-checkbox>
      <h6 class="yellow" *ngIf="showNoHoldpointsFound">
        No Hold Points found!
      </h6>

      <div
        class="d-print-none"
        *ngIf="
          (privileges?.canAddHoldPoints || privileges?.canAddHoldPointsDraft) &&
          (status?.isEditing || status?.isEditingAmendment)
        "
      >
        <div class="button-container">
          <div class="d-flex align-items-center">
            <div
              class="button-wrapper mr-2"
              *ngIf="
                (status?.isEditing || status?.isEditingAmendment) &&
                (holdPoints?.length ?? 0) > 1 &&
                (privileges?.canAddHoldPoints ||
                  privileges?.canAddHoldPointsDraft)
              "
            >
              <button
                *ngIf="!enableReorder"
                mat-icon-button
                [disabled]="
                  scfMaster &&
                  scfMaster.status == formStatusEnum.Draft &&
                  scfMaster.editingBy?.id != currentUser?.id &&
                  scfMaster.editingBy?.id
                "
                color="accent"
                matTooltip="Enable Reorder Holdpoints"
                [ngClass]="{
                  gray:
                    scfMaster &&
                    scfMaster.status == formStatusEnum.Draft &&
                    scfMaster.editingBy?.id != currentUser?.id &&
                    scfMaster.editingBy?.id,
                }"
                (click)="enableReorder = !enableReorder"
              >
                <mat-icon>swipe_vertical</mat-icon>
              </button>
              <button
                mat-mini-fab
                *ngIf="enableReorder"
                [disabled]="
                  scfMaster &&
                  scfMaster.status == formStatusEnum.Draft &&
                  scfMaster.editingBy?.id != currentUser?.id &&
                  scfMaster.editingBy?.id
                "
                color="accent"
                matTooltip="Disable Reorder Holdpoints"
                [ngClass]="{
                  gray:
                    scfMaster &&
                    scfMaster.status == formStatusEnum.Draft &&
                    scfMaster.editingBy?.id != currentUser?.id &&
                    scfMaster.editingBy?.id,
                }"
                (click)="enableReorder = !enableReorder"
              >
                <mat-icon class="white">swipe_vertical</mat-icon>
              </button>
            </div>

            <button
              mat-flat-button
              class="float-right"
              color="accent"
              (click)="createHoldPoint()"
              *ngIf="
                (privileges?.canAddHoldPoints ||
                  privileges?.canAddHoldPointsDraft) &&
                (status?.isEditing || status?.isEditingAmendment)
              "
              [disabled]="
                scfMaster &&
                scfMaster.status == formStatusEnum.Draft &&
                scfMaster.editingBy?.id != currentUser?.id &&
                scfMaster.editingBy?.id
              "
            >
              Add Hold Point
            </button>
          </div>

          <div
            *ngIf="
              scfMaster &&
              scfMaster.status == formStatusEnum.Draft &&
              scfMaster.editingBy?.id != currentUser?.id &&
              scfMaster.editingBy?.id
            "
            class="disabled-message"
          >
            You cannot add or modify hold points while the form is being edited
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    cdkDropList
    [cdkDropListData]="holdPoints"
    [cdkDropListSortPredicate]="canSortHoldPoint"
    (cdkDropListDropped)="drop($event)"
    class="holdpoints-container"
    cdkDropListLockAxis="y"
    [cdkDropListDisabled]="isLogView"
  >
    <div
      *ngFor="let hp of holdPoints; let i = index"
      cdkDrag
      [cdkDragData]="hp"
      class="d-flex align-items-center"
      [cdkDragDisabled]="isHoldPointDragDisabled(hp)"
    >
      <button
        mat-icon-button
        *ngIf="enableReorder"
        cdkDragHandle
        class="yellow"
        [ngClass]="{
          'drag-disabled': isHoldPointDragDisabled(hp),
        }"
        [cdkDragHandleDisabled]="isHoldPointDragDisabled(hp)"
        [disabled]="isHoldPointDragDisabled(hp)"
      >
        <mat-icon>reorder</mat-icon>
      </button>
      <div
        class="row full-width border-hp relative mx-1"
        [ngClass]="{
          'border-hp-amendment': diffHoldpoint(hp),
        }"
        *ngIf="
          !hp.amendmentID ||
          (hp.amendmentID &&
            (status?.isViewingAmendment || !amendmentActive() || isLogView))
        "
      >
        <span
          class="holdpoint-title"
          *ngIf="hp.number"
          [ngClass]="{
            'holdpoint-amendment-title': diffHoldpoint(hp),
          }"
          >Hold Point {{ hp.number
          }}<span class="ml-2" *ngIf="hp.amendmentID && diffHoldpoint(hp)"
            >Amendment {{ hp.amendmentNumber }}</span
          ></span
        >
        <span class="holdpoint-buttons d-print-none">
          <button
            type="button"
            mat-icon-button
            color="accent"
            (click)="editHoldPoint(hp)"
            *ngIf="
              (privileges?.canAddHoldPoints ||
                privileges?.canAddHoldPointsDraft) &&
              holdPointUnsigned(hp) &&
              (status?.isEditing || status?.isEditingAmendment)
            "
            [disabled]="
              scfMaster &&
              scfMaster.status == formStatusEnum.Draft &&
              scfMaster.editingBy?.id != currentUser?.id &&
              scfMaster.editingBy?.id
            "
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            color="warn"
            (click)="deleteHoldPoint(hp)"
            *ngIf="
              (privileges?.canAddHoldPoints ||
                privileges?.canAddHoldPointsDraft) &&
              holdPointUnsigned(hp) &&
              (status?.isEditing || status?.isEditingAmendment)
            "
            [disabled]="
              scfMaster &&
              scfMaster.status == formStatusEnum.Draft &&
              scfMaster.editingBy?.id != currentUser?.id &&
              scfMaster.editingBy?.id
            "
          >
            <mat-icon>delete</mat-icon>
          </button>
        </span>
        <div class="col-12 mt-3">
          <div class="holdpoint-comment">
            <span [innerHTML]="hp.description"> </span>
          </div>
          <div class="row px-2 justify-content-center">
            <div
              class="col px-1 pb-2"
              id="{{ s.disapproveAction }}"
              *ngFor="let s of hp.signatures"
            >
              <button-signature
                #btnSign
                [roleIds]="s.roles"
                [roleCodes]="s.roleCodes"
                [user]="s.approvedBy"
                [title]="s.name"
                [disabled]="s.disabled"
                [value]="s.approved"
                [showApprove]="s.approveAction"
                [showDisapprove]="s.disapproveAction"
                [showUnapprove]="s.unapproveAction"
                [date]="s.approvedOn"
                [showTestApprove]="canTestSign(s)"
                (approve)="approve(s)"
                (disapprove)="disapprove(s, $event)"
                (unapprove)="unapprove(s)"
                (testApprove)="testSign(s)"
                [enabled]="s.enabled"
                [userNames]="s.userNames"
              ></button-signature>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
